import Lenis from 'lenis'

import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

export class Scroll {
  constructor () {
    gsap.registerPlugin(ScrollTrigger)

    const lenis = new Lenis({
      lerp: 0.1,
      duration: 0.7,
      wheelMultiplier: 0.7,
    })

    // Expose pour debug / filets éventuels
    window.__lenis = lenis

    lenis.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)

    // Recalcule les starts après fonts / images / layout
    requestAnimationFrame(() => ScrollTrigger.refresh())
    window.addEventListener('load', () => ScrollTrigger.refresh())
  }
}
